import {
	CameraOutlined,
	EditOutlined,
	FilePdfOutlined,
	MailOutlined,
	SettingOutlined,
} from "@ant-design/icons";
import { BodhiButton, BodhiTag } from "@bodhistreams/ui";
import { useRef } from "react";
import { getInitials } from "./profileUtils";
import "./ProfileHeader.css";

const ProfileHeader = ({
	user,
	canAccessCertificate,
	isUploadingAvatar,
	isDeletingAvatar,
	isManagingSubscription,
	onAvatarChange,
	onDeleteAvatar,
	onOpenCertificate,
	onEdit,
	onManageSubscription,
}) => {
	const fileInputRef = useRef(null);

	return (
		<div className="profile-header">
			<div className="profile-header-body">
				<div className="profile-id">
					<div className="profile-avatar-wrap">
						{user?.profile_picture_url ? (
							<img
								className="profile-avatar"
								src={user.profile_picture_url}
								alt="Profile"
							/>
						) : (
							<div className="profile-avatar-placeholder">
								{getInitials(user)}
							</div>
						)}
						<button
							type="button"
							className="profile-avatar-btn"
							onClick={() => fileInputRef.current?.click()}
							disabled={isUploadingAvatar}
							aria-label="Change profile picture"
						>
							<CameraOutlined />
						</button>
						<input
							ref={fileInputRef}
							type="file"
							accept="image/jpeg,image/png,image/webp"
							style={{ display: "none" }}
							onChange={onAvatarChange}
						/>
					</div>
					<div>
						<h1 className="profile-name">
							{user?.first_name
								? `${user.first_name} ${user.last_name}`
								: "User Profile"}
						</h1>
						<div className="profile-meta">
							<MailOutlined className="profile-meta-icon" />
							<span className="profile-email">{user?.email}</span>
							<BodhiTag color={user?.is_verified ? "success" : "amber"}>
								{user?.is_verified ? "Verified" : "Unverified"}
							</BodhiTag>
						</div>
						{user?.profile_picture_url && (
							<button
								type="button"
								className="profile-avatar-remove"
								onClick={onDeleteAvatar}
								disabled={isDeletingAvatar}
							>
								Remove photo
							</button>
						)}
					</div>
				</div>

				<div className="profile-actions">
					{canAccessCertificate && (
						<BodhiButton
							variant="ghost"
							icon={<FilePdfOutlined />}
							onClick={onOpenCertificate}
						>
							License Certificate
						</BodhiButton>
					)}
					<BodhiButton variant="ghost" icon={<EditOutlined />} onClick={onEdit}>
						Edit Profile
					</BodhiButton>
					<BodhiButton
						variant="primary"
						icon={<SettingOutlined />}
						onClick={onManageSubscription}
						loading={isManagingSubscription}
					>
						Manage Subscription
					</BodhiButton>
				</div>
			</div>
		</div>
	);
};

export default ProfileHeader;
